import {ScaleBand} from 'd3';

/**
 * Given a position along a scale, return the domain value that corresponds to that position.
 *
 * For continuous scales, use their built-in invert() method.
 */
export default function invertBandScale<T extends {}>(scale: ScaleBand<T>, scalePosition: number): T | null {
  const stepWidth = scale.step();
  const index = Math.floor(scalePosition / stepWidth);
  return index < 0 || index >= scale.domain().length ? null : scale.domain()[index];
}
